<template>
	<div class="upload">
		<div class="select" v-if="select" >
			<input type="file" @click="input" @change="inputChange" />
			<div class="plus"></div>
			<p v-if="type == 1">请上传身份证原件人像面，要求清晰完整</p>
			<p v-else-if="type == 2">请上传身份证原件国徽面，要求清晰完整</p>
			<p v-else-if="type == 3">请上传营业执照，要求清晰完整</p>
		</div>

		<div class="prpgress" v-if="prpgress">
			<p>{{percent}}%</p>
			<div :style="{width:percent + '%'}"></div>
		</div>


		<div class="result" v-if="result">
			<img :src="src" alt="" />
			<span>X</span>
		</div>

		<div class="result" v-if="success">
			<img :src=" url + src" alt="" />
		</div>






	</div>
</template>

<script>
	import {
		getCheck_id,
		business_license
	} from '../api/my/account.js';
	export default {
		data() {
			return {
				select: false, //上传之前的显示隐藏
				prpgress: false, //上传中的显示隐藏
				result: false, //上传完成预览的显示隐藏
				success: false, //已经上传完成的显示隐藏
				src: null, //图片数据
				percent: 0, //进度条
				obj: { //具体数据

				},
			}
		},
		props: {
			legalExts: Array, //上传格式
			sizeLimit: Number, //图片大小
			apiurl: String, //上传图片地址
			type: Number, //1 身份证证明  2.身份证背面  3.营业执照
			headers: Object, //请求头
			url: String, //图片前缀
			srcValue: String, //图片路径
		},
		watch:{
			srcValue: {
				immediate: true, // 立即触发
				deep: true, // 深度监听对象变化
				handler(newVal) {
					
					this.src =  newVal;
					console.log('sss',this.src)
					// 页面加载时判断src是否有值 有显示不带X号的图  
					if (this.src) {
						this.select = false;
						this.prpgress = false;
						this.result = false;
						this.success = true;
					} else {
						this.select = true;
						this.prpgress = false;
						this.result = false;
						this.success = false;
					}
					
				}
			}
		},
		mounted() {
			
		},
		methods: {
			// 切换显示
			showArea(areaName) {

				if (areaName == 'select') {
					this.select = true;
					this.prpgress = false;
					this.result = false;
					this.success = false;
				} else if (areaName == 'prpgress') {
					this.select = false;
					this.prpgress = true;
					this.result = false;
					this.success = false;
				} else if (areaName == 'result') {
					this.select = false;
					this.prpgress = false;
					this.result = true;
					this.success = false;
				}
			},
			// 进度值 
			setProgress(value) {
				this.percent = value;
			},
			// 点击input弹出选择框
			input(e) {
				e.target.value = null;
			},
			// input的值发生变化
			inputChange(e) {
				// 如果目前没有选择什么也不做
				if (e.target.files.length === 0) {
					return;
				}
				const file = e.target.files[0];
				// 1.验证文件类型 大小 
				this.validateFile(file);

				// 2.验证成功后切换 
				if (this.validateFile(file)) {

					// 3.加载页面
					this.showArea('prpgress');

					// 4.加载完成 或者  上传成功后显示   预览图
					const reader = new FileReader();
					reader.onload = e => {
						this.src = e.target.result

					}
					reader.readAsDataURL(file)

					//5. 上传事件
					const that = this;
					that.unload(file, function(val) {
						that.setProgress(val);
					}, function(resp) {
						// that.showArea('result');
						that.showArea(resp);
					}, that)

				}


			},
			// 上传事件
			unload(file, onProgress, onFinish, that) {
				const xhr = new XMLHttpRequest();
				xhr.upload.onprogress = (e) => {
					const percent = Math.floor(e.loaded / e.total * 100);
					onProgress(percent);
				};
				xhr.onload = function() {
					const resp = JSON.parse(xhr.responseText);
					if (that.type == 1) {
						onFinish('result')
						getCheck_id(that.url + resp.url).then(response => {
							if (response.data.code == 200 && response.status == 200) {
								//身份证人像面验证将需要的值传给父组件
								const obj = {
									nation:response.data.data.Nation,
									birthday:response.data.data.Birth,
									sex:response.data.data.Sex,
									card_address:response.data.data.Address,
									card_front_image:resp.url,
									IdNum:response.data.data.IdNum,
									Name:response.data.data.Name,
								}
								that.$emit('handlRen',obj)
								
							} else {
								that.$message.error(response.data.message);
								that.showArea('select');
								that.src = null;
							}
						})

					} else if (that.type == 2) {
						onFinish('result')
						getCheck_id(that.url + resp.url).then(response => {
							if (response.data.code == 200 && response.status == 200) {
								//身份证国徽验证将需要的值传给父组件
								const obj = {
									valid_date:response.data.data.ValidDate,
									card_side_image: resp.url
								}
                
								that.$emit('handlFan',obj)
							} else {
								that.$message.error(response.data.message);
								that.showArea('select');
								that.src = null;
							}
						})
					} else if (that.type == 3) {
						onFinish('result')
						business_license(that.url + resp.url).then(response => {
							if (response.data.code == 200 && response.status == 200) {
								//营业执照将需要的值传给父组件
								const obj = {
									address:response.data.data.Address,
									period:response.data.data.Period,
									person:response.data.data.Person,
									set_date:response.data.data.SetDate,
									RegNum:response.data.data.RegNum,
									Name:response.data.data.Name,
									license_image: resp.url
								}
								
								that.$emit('handlYing',obj)
							} else {
								that.$message.error(response.data.message);
								that.showArea('select');
								that.src = null;
							}
						})
					} else {
						return
					}
				};
				xhr.open('post', this.apiurl);
				xhr.setRequestHeader('Authorization', this.headers.Authorization)
				const form = new FormData();
				form.append('file', file);
				xhr.send(form);
			},
			// 验证 文件 格式
			validateFile(file) {
				// 以下数据可以从父组件传过来
				const sizeLimit = this.sizeLimit; //文件大小
				const legalExts = this.legalExts; //文件格式

				// 如果不是数组就用以下判断 反之循环数组在进行以下判断
				if (file.size > sizeLimit) {
					alert('文件尺寸过大');
					return false;
				}
				const name = file.name.toLowerCase();
				if (!legalExts.some((ext) => name.endsWith(ext))) {
					alert('文件类型不正确');
					return false;
				}
				return true;
			},
		}
	}
</script>

<style scoped lang="scss">
	.upload {
		width: 240px;
		height: 160px;
		border: 1px dashed #D43733;
		cursor: pointer;


		// 上传中样式
		.select {
			width: 100%;
			// height: 100%;
			position: relative;
			text-align: center;

			input[type="file"] {
				position: absolute;
				display: inline-block;
				width: 100%;
				height: 100%;
				opacity: 0;
				z-index: 2;
				cursor: pointer;
			}

			.plus {
				width: 32px;
				height: 32px;
				background-image: url('../assets/img/my/guanbi.png');
				background-size: 100%;
				margin-top: 47px;
				margin-left: 104px;

			}

			p {
				font-weight: 400;
				font-size: 12px;
				color: #D43733;
				margin-top: 17px;
			}
		}

		// 上传中样式
		.prpgress {
			width: 90%;
			height: 100%;
			padding-left: 5%;
			padding-right: 5%;

			p {
				width: 100%;
				text-align: center;
				font-weight: 400;
				font-size: 12px;
				color: #D43733;
				margin-top: 47px;
			}

			div {
				width: 0;
				height: 10px;
				border-radius: 10px;
				background-color: #D43733;
				margin-top: 10px;
			}
		}


		// 上传完成样式
		.result {
			width: 100%;
			height: 100%;
			position: relative;

			img {
				width: 100%;
				height: 100%;
			}

			span {
				position: absolute;
				right: 10px;
				top: 10px;
				cursor: pointer;
			}
		}
	}
</style>